import { render, staticRenderFns } from "./professionalList.vue?vue&type=template&id=187eac94&scoped=true"
import script from "./professionalList.vue?vue&type=script&lang=js"
export * from "./professionalList.vue?vue&type=script&lang=js"
import style0 from "./professionalList.vue?vue&type=style&index=0&id=187eac94&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187eac94",
  null
  
)

export default component.exports